import { GridColumn, GridItem, GridRow } from "commons/ui/Grid";
import InputText from "commons/ui/input/InputText";
import IntegerInput from "commons/ui/input/IntegerInput";
import Select from "commons/ui/input/Select";
import SwitchInput from "commons/ui/input/SwitchInput";
import Paper from "commons/ui/Paper";

import ExtensionsProporsionInfo from "components/subComponents/ExtensionsProporsionInfo";
import MetaFieldsForm from "components/subComponents/MetaFieldsForm";
import AttachmentPicker from "components/ui/AttachmentPicker";

import useRugianoProjectForm from "hooks/form/useRugianoProjectForm";

import { RugianoProjectTypeEnum } from "types/api/rugianoProject";
import { DesktopOrMobile } from "types/enums";

function RugianoProjectForm({ projectId }: { projectId?: string }) {
    const { setDesktopMobileImageThumbnail, formHook } = useRugianoProjectForm({ projectId });

    const { checkErrorVisibility, setValue, form } = formHook;

    return (
        <GridItem>
            <GridRow>
                <GridItem className={"col-xs-12-12"}>
                    <Paper>
                        <GridColumn>
                            <GridRow>
                                <GridItem className={"title-margin"}>
                                    <h1>Progetto</h1>
                                </GridItem>
                            </GridRow>

                            <GridRow>
                                <GridItem className={"col-xs-12-3"}>
                                    <Select
                                        label="Tipologia"
                                        options={[
                                            {
                                                value: RugianoProjectTypeEnum.CONTRACT,
                                                label: "Contract",
                                            },
                                            {
                                                value: RugianoProjectTypeEnum.PRIVATE,
                                                label: "Private",
                                            },
                                        ]}
                                        value={form.type}
                                        setValue={setValue}
                                        path={"type"}
                                        checkErrorVisibility={checkErrorVisibility}
                                    />
                                </GridItem>

                                <GridItem className={"col-xs-12-3"}>
                                    <InputText
                                        label={"Nome"}
                                        value={form.name}
                                        setValue={setValue}
                                        path={"name"}
                                        checkErrorVisibility={checkErrorVisibility}
                                    />
                                </GridItem>

                                <GridItem className={"col-xs-12-3"}>
                                    <InputText
                                        label={"Slug"}
                                        value={form.slug}
                                        setValue={setValue}
                                        path={"slug"}
                                        checkErrorVisibility={checkErrorVisibility}
                                    />
                                </GridItem>

                                <GridItem className={"col-xs-12-3"}>
                                    <IntegerInput
                                        label={"Ordinamento"}
                                        value={form.graphical_order}
                                        setValue={setValue}
                                        path={"graphical_order"}
                                        checkErrorVisibility={checkErrorVisibility}
                                    />
                                </GridItem>
                            </GridRow>

                            <GridRow>
                                <GridItem className={"col-xs-12-3"}>
                                    <InputText
                                        label={"Designer"}
                                        value={form.designer}
                                        setValue={setValue}
                                        path={"designer"}
                                        checkErrorVisibility={checkErrorVisibility}
                                    />
                                </GridItem>

                                <GridItem className={"col-xs-12-3"}>
                                    <InputText
                                        label={"Luogo"}
                                        value={form.location}
                                        setValue={setValue}
                                        path={"location"}
                                        checkErrorVisibility={checkErrorVisibility}
                                    />
                                </GridItem>

                                <GridItem className={"col-xs-12-3"}>
                                    <InputText
                                        label={"Anno"}
                                        value={form.year}
                                        setValue={setValue}
                                        path={"year"}
                                        checkErrorVisibility={checkErrorVisibility}
                                    />
                                </GridItem>

                                <GridItem className={"col-xs-12-3"}>
                                    <SwitchInput
                                        label={"Visibile"}
                                        setValue={setValue}
                                        checked={form.enabled}
                                        path={"enabled"}
                                    />
                                </GridItem>
                            </GridRow>

                            <GridRow>
                                <GridItem className={"col-xs-12-6"}>
                                    <GridRow>
                                        <GridItem className={"col-xs-12-12 title-margin"}>
                                            <h2>Thumbnail</h2>
                                        </GridItem>
                                    </GridRow>

                                    <ExtensionsProporsionInfo
                                        desktopText={"600x338px (max 60KB)"}
                                        mobileText={"400x225px (max 50KB)"}
                                        proportion={"16:9"}
                                    />

                                    <GridRow>
                                        <GridItem
                                            className={"col-xl-12-6 col-lg-24-12 col-xs-24-12"}
                                        >
                                            <AttachmentPicker
                                                buttonLabel={"Desktop"}
                                                setFile={(file) =>
                                                    setDesktopMobileImageThumbnail(
                                                        file,
                                                        DesktopOrMobile.desktop,
                                                    )
                                                }
                                                file={form.thumb.desktop}
                                                accept={".png,.jpg,.jpeg"}
                                                errors={checkErrorVisibility("thumb.desktop")}
                                            />
                                        </GridItem>

                                        <GridItem
                                            className={"col-xl-12-6 col-lg-24-12 col-xs-24-12"}
                                        >
                                            <AttachmentPicker
                                                buttonLabel={"Mobile"}
                                                setFile={(file) =>
                                                    setDesktopMobileImageThumbnail(
                                                        file,
                                                        DesktopOrMobile.mobile,
                                                    )
                                                }
                                                file={form.thumb.mobile}
                                                accept={".png,.jpg,.jpeg"}
                                                errors={checkErrorVisibility("thumb.mobile")}
                                            />
                                        </GridItem>
                                    </GridRow>
                                </GridItem>
                            </GridRow>

                            <MetaFieldsForm
                                text={form.text}
                                setValue={setValue}
                                checkErrorVisibility={checkErrorVisibility}
                            />
                        </GridColumn>
                    </Paper>
                </GridItem>
            </GridRow>
        </GridItem>
    );
}

export default RugianoProjectForm;
